<phx-sheet
  [phxExpanded]="phxExpanded"
  [phxPeekHeight]="phxPeekHeight"
  [phxTopOffset]="phxTopOffset"
  [phxAutoClose]="phxAutoClose"
  (phxExpandedChange)="setExpanded($event)"
  (phxBackdropClicked)="phxBackdropClicked.emit()"
  (phxDismissAttempt)="phxDismissAttempt.emit()"
>
  <div class="phx-bottom-sheet-panel">
    <div class="phx-bottom-sheet-header" phx-sheet-drag-handle>
      <div class="phx-bottom-sheet-header-content">
        <ng-content select="[phx-bottom-sheet-header]"></ng-content>
      </div>
      <button
        *ngIf="!phxHideCloseIcon && phxExpanded"
        class="phx-bottom-sheet-close-btn"
        phx-icon-button
        [phxIcon]="CloseIcon"
        phxIconButtonSize="small"
        (pointerdown)="$event.stopPropagation()"
        (click)="onCloseClick()"
      ></button>
    </div>
    <ng-content select="[phx-bottom-sheet-body]"></ng-content>
    <ng-content select="[phx-bottom-sheet-footer]"></ng-content>
  </div>
</phx-sheet>
